import React, { Component } from "react";
import { Row, Col, Table, Drawer, Button } from "antd";
import { withRouter } from "react-router-dom";
import FileDownload from "js-file-download";
import "./FolderCase.css";
import PlusIcon from "../../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../../Components/MyComponent/ButtonLinkIcon";
import FolderCaseAdd from "./FolderCaseAdd";
import { API } from "../../../API/API";
class FolderCaseList extends Component {
  state = {
    data: [],
    invitationid: this.props.invitationid,
    selectedID: 0,
    showNewInputForm: false,
    dKey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getFolderCaseList?invitationid=" + this.state.invitationid).then(
      (response) => {
        if (response.status === 200) {
          this.setState((prevState) => ({
            data: response.data.retData,
            dkey: prevState.dkey + 1,
          }));
        }
      }
    );
  };
  showNewInputFormHandler = (show, id) => {
    this.setState({
      showNewInputForm: show,
      selectedID: id,
    });
    if (show === false) {
      this.getData();
    }
  };
  onDownLoadFile = (sourceid, sourcetype, filename) => {
    API.get("/download?sourceid=" + sourceid + "&sourcetype=" + sourcetype, {
      responseType: "blob",
    }).then((response) => {
      if (response.status === 200) {
        console.log(response);
        FileDownload(response.data, filename);
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Хавтаст хэргийн нэр",
        dataIndex: "documentname",
        key: "documentname",
        width: "10%",
        align: "left",
      },
      {
        title: "Файл",
        dataIndex: "filename",
        key: "filename",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              style={{ fontWeight: "500", color: "#0358A7" }}
              type="link"
              onClick={() =>
                this.onDownLoadFile(
                  record.sourceid,
                  record.sourcetype,
                  record.filename
                )
              }
            >
              {record.filename}
            </Button>
          );
        },
      },
    ];
    return (
      <div className="Container" key={this.state.dkey}>
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Хавтаст хэрэг</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0)}
                  icon={<PlusIcon />}
                  name="Хавтаст хэрэг нэмэх"
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="foldercase">
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="foldercaseid"
            scroll={{ y: 340 }}
          />
        </div>
        <Drawer
          title="Хавтаст хэрэх нэмэх"
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
          style
        >
          <FolderCaseAdd
            showForm={this.showNewInputFormHandler}
            invitationid={this.state.invitationid}
          ></FolderCaseAdd>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(FolderCaseList);
